tinymce.init({
    selector: '.initTinymce',
    plugins: 'preview importcss searchreplace autolink directionality code visualblocks visualchars fullscreen link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
    menubar: 'file edit view insert format tools table help',
    toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview print | insertfile media template link anchor codesample | ltr rtl',
    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quicktable',
    toolbar_mode: 'sliding',
    contextmenu: 'link media imagetools table',
    importcss_append: true,
    language: 'pt_BR'
});
